import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pmsRenderWidget]'
})
export class RenderWidgetDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
